import { dragElement } from './drag'
import { visibleComputationArea } from './map/layer-tools';
import { login, logout } from './request/authentication'
import { submitUserInfo } from './request/authorization'
import { saveGeometryToFile, saveToFile } from './save'
import { getUser } from './user'
import * as up from './upload';
import { findInHeader, table2csv } from './table'

const stage = ['home', 'selection', 'results', 'user'];

let current = 'home';

const move = (from, to) => {
  const f = document.getElementById(from);
  const t = document.getElementById(to);
  f.hidden = true;
  t.hidden = false;
  current = to;
};

const wizard = document.getElementById('wizard');
const results = document.getElementById('resultsContent');
const slol = document.getElementById('scrollableListOfLayers');
const userForm = document.getElementById('user');
const listOfUsers = document.getElementById('listOfUsers');
const fMail = document.getElementById('fMail');
const fExpiration = document.getElementById('fExpiration');

const initializeExpirationField = () => {
  // fExpiration.valueAsDate = new Date(); // did not work for webkit
  // const today = new Date();
  const in2years = new Date();
  in2years.setFullYear(in2years.getFullYear() + 2);
  const iso = new Date(in2years).toISOString().substring(0, 10); // yyyy-mm-dd
  fExpiration.defaultValue = iso;
  fExpiration.value = iso;
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  fExpiration.min = new Date(tomorrow).toISOString().substring(0, 10);
  fExpiration.max = iso;
};

const adaptWizardHeightAccordingTo = (content) => {
  // console.log('Add scrollbar if', content.id, 'overflows');
  // Consider header and footer height:
  const fixedHeight = (content.id === 'resultsContent') ? 117 : 130;
  // const rect = entries[0].contentRect;
  // const width = rect.width;
  // const height = rect.height;
  // On full screen wizard (double click bottom-right corner or
  // when results table is big enough), there is no scrollbar. This is
  // because we do not want to set fixed dimensions at the beginning and
  // loose adaptability to content. Let's show scrollbar if full screen:
  // const wizardWidth = wizard.offsetWidth;
  const wizardHeight = wizard.offsetHeight;
  const contentHeight = content.scrollHeight;
  const visibleContentHeight = content.offsetHeight;
  // console.log(
  //   wizardHeight,
  //   contentHeight, visibleContentHeight,
  //   wizard.style.height
  // );
  const tolerance = 1;
  const scrollbarIsVisible = (visibleContentHeight + tolerance < contentHeight);
  // console.log(`scrollbar is ${scrollbarIsVisible ? '' : 'not '}visible`);
  if (!contentHeight || scrollbarIsVisible) return;
  // if (scrollbarIsVisible && !manuallyResizing) return;
  // if (wizardHeight - fixedHeight < visibleContentHeight) {
  if (wizardHeight - fixedHeight < contentHeight) {
    // console.log('scrollbar is needed, set 100%');
    wizard.style.height = '100%';
  } else if (wizard.style.height === '100%') {
    // console.log('remove 100%');
    wizard.style.height = '';
  }
};

export const moveTo = (stage) => move(current, stage);

export const initialize = () => {
  // Make side and top borders draggagle:
  dragElement('wizard', 'topDragHandle');
  dragElement('wizard', 'sideDragHandle');

  // onresize only works for window, we need it for wizard element:
  const resize_ob = new ResizeObserver(entries => {
    const content = entries[0].target;
    // console.log('Resized', content.id);
    adaptWizardHeightAccordingTo(content); // use scrollbar if content overflows
  });
  // Start observing for resize:
  resize_ob.observe(results);
  resize_ob.observe(slol);
  resize_ob.observe(listOfUsers); // worked better than userForm on Webkit
  // let manuallyResizing = false;
  // wizard.onmousedown = () => manuallyResizing = true;
  // wizard.onmouseup = () => manuallyResizing = false;

  document.getElementById('profileBtn').onclick = showUserForm;
  document.getElementById('manageUsersBtn').onclick = showUserForm;
  document.getElementById('loginBtn').onclick = login;
  document.getElementById('logoutBtn').onclick = logout;

  document.getElementById('closeBtn').onclick = () => {
    wizard.style.display = 'none';
  };

  document.getElementById('backToHomeBtn').onclick = () => {
    visibleComputationArea(false);
    moveTo('home');
  };
  document.getElementById('backHomeFromUserBtn').onclick = () => {
    fMail.disabled = false;
    wizard.classList.remove('activation', 'profile', 'registration');
    moveTo('home');
  };

  document.getElementById('saveBtn').onclick = () => {
    // console.log('Save to CSV-file');
    const csvArray = [];
    const v = '\u25BE'; // triangle pointing down
    const d = [];
    results.querySelectorAll('u').forEach(u => d.push(`${v} ${u.innerHTML}`));
    const table = [];
    results.querySelectorAll('table').forEach(t => table.push(t));
    const ncMax = table.map(t => t.rows[0]?.cells.length ?? 0).sort().pop();
    const header = table[table.length - 1].firstElementChild;
    const emptyColumnIndeces = [
      findInHeader(['Kommune', 'Arealbruk'], header),
      findInHeader('Arealbruk plan', header),
      []
    ];
    table.forEach((t, i) => {
      const n = (i < 1) ? '' : '\n';
      csvArray.push(`${n}${d[i]}${';'.repeat(ncMax - 1)}`);
      const visible = t.offsetWidth > 0 || t.offsetHeight > 0;
      if (visible) csvArray.push(table2csv(t, emptyColumnIndeces[i]));
    });
    const bom = '\uFEFF'; // add BOM to tell Excel to open with rigth charset
    const csv = bom + csvArray.join('\n');
    // Do not save with Norwegian minus, to be able to use spreadsheet formulas:
    saveToFile(csv.replaceAll('−', '-'), 'utslipp.csv');
    saveToFile('', 'utslipp.pdf');
    saveToFile('', 'utslipp.png');
    saveGeometryToFile();
  };

  up.initialize(); // activate button

  userForm.onsubmit = submitUserInfo; // can be activation, registration or edit
  initializeExpirationField();
};

export const showUserForm = (action) => {
  wizard.classList.remove('activation', 'profile', 'registration');
  if (action === 'activation') wizard.classList.add(action);
  else if (['loggedInUserName', 'profileBtn'].indexOf(action.target.id) > -1) {
    wizard.classList.add('profile');
    fMail.value = getUser()?.email || '';
  } else {
    wizard.classList.add('registration');
    fMail.value = '';
  }
  fMail.disabled = false;
  userForm.querySelector('#fError').hidden = true; // red msg
  moveTo('user');
  adaptWizardHeightAccordingTo(listOfUsers); // use scrollbar if it overflows
};

const setVisibility = (v) => {
  wizard.style.display = v;
  document.getElementById('wizardSwitch').style.display = v;
};
export const hide = () => setVisibility('none');
export const show = () => setVisibility('block');
